<div class="checkout-rewards-wrap">

    <!-- Phone entry (only show if rewards enabled) -->
    <div class="phone-row" *ngIf="!lookupDone && rewardsEnabled">
        <input class="phone-input"
               type="tel"
               inputmode="numeric"
               maxlength="15"
               [(ngModel)]="phoneNumber"
               placeholder="Phone # for rewards (optional)"
               (keydown.enter)="lookupCustomer()">
        <button class="phone-btn" (click)="lookupCustomer()" [disabled]="lookupLoading || !phoneNumber">
            <mat-icon>loyalty</mat-icon>
            {{ lookupLoading ? 'Checking...' : 'Check Rewards' }}
        </button>
    </div>

    <!-- After lookup: show identified customer + reward picker -->
    <div class="customer-block" *ngIf="lookupDone && rewardsEnabled">
        <div class="customer-line">
            <mat-icon>person</mat-icon>
            <span>{{ phoneNumber }}</span>
            <button class="link-btn" (click)="clearCustomer()">change</button>
        </div>

        <!-- Intro promo welcome offer (for new customers) -->
        <div class="intro-promo-banner" *ngIf="introPromo && introPromoSelected">
            <div class="intro-promo-header">
                <mat-icon>celebration</mat-icon>
                <span>Welcome Offer</span>
            </div>
            <div class="intro-promo-body">
                <strong>{{ introPromo.name }}</strong>
                <span *ngIf="introPromo.description"> — {{ introPromo.description }}</span>
                <div class="intro-promo-value">
                    <span *ngIf="introPromo.discountType === 'PERCENT'">{{ introPromo.discountValue }}% off</span>
                    <span *ngIf="introPromo.discountType === 'FIXED'">${{ (introPromo.discountValue / 100).toFixed(2) }} off</span>
                </div>
            </div>
        </div>

        <!-- No rewards available -->
        <div class="no-rewards-msg" *ngIf="autoRewards.length === 0 && !introPromo">
            <mat-icon>info</mat-icon>
            <span>No rewards earned yet — your visit will still be counted.</span>
        </div>

        <!-- Reward picker -->
        <div class="reward-picker" *ngIf="autoRewards.length > 0 && !promoApplied">
            <div class="picker-title">Choose a reward to apply:</div>

            <label class="reward-option" *ngFor="let r of autoRewards"
                   [class.selected]="selectedRewardKey === r.promoId">
                <input type="radio" name="rewardChoice"
                       [value]="r.promoId"
                       [checked]="selectedRewardKey === r.promoId"
                       (change)="onRewardChange(r.promoId)">
                <div class="reward-body">
                    <div class="reward-name">
                        <mat-icon *ngIf="r.rewardType === 'FREE_ITEM'">card_giftcard</mat-icon>
                        <mat-icon *ngIf="r.rewardType === 'VISIT_REWARD'">loyalty</mat-icon>
                        {{ r.promoName }}
                    </div>
                    <div class="reward-detail" *ngIf="r.rewardType === 'FREE_ITEM'">
                        Free {{ r.freeItemName }}
                        <span class="hint" *ngIf="!isFreeItemInCart(r)">(add {{ r.freeItemName }} to cart to use)</span>
                    </div>
                    <div class="reward-detail" *ngIf="r.rewardType === 'VISIT_REWARD'">
                        <span *ngIf="r.discountType === 'PERCENT'">{{ r.discountValue }}% off</span>
                        <span *ngIf="r.discountType === 'FIXED'">${{ (r.discountValue / 100).toFixed(2) }} off</span>
                    </div>
                </div>
            </label>

            <label class="reward-option skip-option"
                   [class.selected]="selectedRewardKey === 'none'">
                <input type="radio" name="rewardChoice"
                       value="none"
                       [checked]="selectedRewardKey === 'none'"
                       (change)="onRewardChange('none')">
                <div class="reward-body">
                    <div class="reward-name">
                        <mat-icon>do_not_disturb</mat-icon>
                        Skip reward (just count my visit)
                    </div>
                    <div class="reward-detail">Save it for next time.</div>
                </div>
            </label>
        </div>
    </div>

    <!-- Rewards disabled notice -->
    <div class="no-rewards-msg" *ngIf="!rewardsEnabled">
        <mat-icon>info</mat-icon>
        <span>Rewards are not enabled. You can still enter a promo code below.</span>
    </div>

    <!-- Manual promo input (always available unless one's already applied) -->
    <div class="promo-section">
        <div class="promo-input-row" *ngIf="!promoApplied">
            <input class="promo-input"
                   [(ngModel)]="promoCodeInput"
                   placeholder="Have a promo code?"
                   (keydown.enter)="applyPromoCode()">
            <button class="promo-apply-btn" (click)="applyPromoCode()"
                    [disabled]="!promoCodeInput || promoValidating">
                {{ promoValidating ? 'Checking...' : 'Apply' }}
            </button>
        </div>

        <div class="promo-applied-badge" *ngIf="promoApplied && appliedPromo">
            <mat-icon>check_circle</mat-icon>
            {{ appliedPromo.promoName }}: {{ appliedPromoDisplay() }} applied
            <button class="promo-remove-btn" (click)="removePromoCode()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>
